export default "__VITE_ASSET__Cfl$yjDI__"